import React from "react";
import { Carousel } from "react-responsive-carousel";
import Banner from "../../assets/bannerdevs.png"
import styles from "./styles.module.css"
import { useNavigate } from "react-router-dom";

const configs = {
    autoPlay: true,
    showArrows: false,
    showStatus: false,
    showThumbs: false,
    swipeable: true,
    showLabels: false,
    infiniteLoop: true,
    interval: 10000,
    emulateTouch: true,
}

export default () => {
    const navigate = useNavigate()
    return (    
        <Carousel {...configs}>
            <div onClick={() => navigate("/simulador/AU")} className={styles.imgContainer}>
                <img alt="Venda de carros" src={Banner} />
            </div>
        </Carousel>
    );
}
    
